// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_dashboard_dashboard_module_ts":"9b8606bbd9ce563e","src_app_dashboard_header_user-settings_user-settings_module_ts":"fc19dd41eadf7168"}[chunkId] + ".js";
};